import { combineReducers } from 'redux-immutable';

import languageProviderReducer from 'services/Language/reducer';
import authenticationServiceReducer from 'services/Authentication/reducer';
import viewsServiceReducer from 'services/Views/reducer';
import vehiclesServiceReducer from 'services/Vehicles/reducer';
import customersServiceReducer from 'services/Customers/reducer';
import agreementsServiceReducer from 'services/Agreements/reducer';
import fleetSettingsServiceReducer from 'services/FleetSettings/reducer';
import dealershipSettingsServiceReducer from 'services/DealershipSettings/reducer';
import geofencesServiceReducer from 'services/Geofences/reducer';
import plannerReducer from 'services/Planner/reducer';
import publicReducer from 'services/Public/reducer';
import usersServiceReducer from 'services/Users/reducer';
import tripsServiceReducer from 'services/Trips/reducer';
import transactionsServiceReducer from 'services/Transactions/reducer';
import dashboardServiceReducer from 'services/Dashboard/reducer';
import telematicsServiceReducer from 'services/Telematics/reducer';
import hierarchyReducer from 'services/Hierarchy/reducer';

const rootReducer = combineReducers({
  agreements: agreementsServiceReducer,
  auth: authenticationServiceReducer,
  customers: customersServiceReducer,
  dashboard: dashboardServiceReducer,
  dealershipSettings: dealershipSettingsServiceReducer,
  fleetSettings: fleetSettingsServiceReducer,
  geofences: geofencesServiceReducer,
  hierarchy: hierarchyReducer,
  language: languageProviderReducer,
  planner: plannerReducer,
  public: publicReducer,
  telematics: telematicsServiceReducer,
  transactions: transactionsServiceReducer,
  trips: tripsServiceReducer,
  users: usersServiceReducer, // TODO: rework to immutable
  vehicles: vehiclesServiceReducer,
  views: viewsServiceReducer,
});

export default rootReducer;
